'use strict';

angular.module('userRequestEditControllers')

.controller('SideBarBusinessTasksController', ['$scope', '$state', '$stateParams', 'businessProcessService', 'businessProcesses', 'businessTasks', function ($scope, $state, $stateParams, businessProcessService, businessProcesses, businessTasks) {
    $scope.startCollapsed = false;

    $scope.catalogs = {};
    $scope.catalogs.bySystem = false;
    $scope.catalogs.byBusinessTask = true;

    $scope.goBySystemCatalog = function () {
        $scope.goToEditSystemType($scope.firstSystemType, {});
    }

    $scope.businessTasks = businessTasks;

    // Redirect
    var firstBusinessTask = $scope.businessTasks[0];

    if ($state.is('userAccessRequest.edit.taskcatalog.businessactivity')) {
        if (!_.isUndefined(firstBusinessTask)) {
            var destStateParams = $stateParams;
            destStateParams.businessTaskId = firstBusinessTask.BusinessTaskId;

            $state.go('userAccessRequest.edit.taskcatalog.businessactivity.businesstask', destStateParams,
                      { reload: true });
        }
    }

    // Filter on actual business process
    $scope.filteredProcesses = function () {
        return !_.isUndefined(firstBusinessTask);
    }

    $scope.searchProcesses = function () {
        return $scope.ctxSearchBusinessTask.withSearch();
    }

    var updateBusinessProcesses = function () {

        // Search Mode
        if ($scope.searchProcesses()) {
            $scope.businessProcesses = _.chain(businessProcesses)
            .filter(function (process) {
                    return _.findIndex($scope.ctxSearchBusinessTask.businessTasks,
                                        { BusinessProcessId: process.BusinessProcessID }) !== -1;
            })
            .map(function (process) {
                process.FoundBusinessActivities = _.chain(process.BusinessActivities)
                .filter(function (activity) {
                    return _.findIndex($scope.ctxSearchBusinessTask.businessTasks,
                                        { BusinessActivityId: activity.BusinessActivityId }) !== -1;
                })
                .map(function (activity) {
                    activity.FoundBusinessTasks = _.chain($scope.ctxSearchBusinessTask.businessTasks)
                                                   .filter({ BusinessActivityId: activity.BusinessActivityId })
                                                   .sortByAll('Name')
                                                   .value();
                    return activity;
                })
                .value();
                return process;
            })
            .value();
        }

        // Selected Mode
        else if (!_.isUndefined(firstBusinessTask)) {

            $scope.businessProcesses = _.chain(businessProcesses)
            .filter(function (process) {
                return process.BusinessProcessID === firstBusinessTask.BusinessProcessId;
            })
            .map(function (process) {
                process.FoundBusinessActivities = _.chain(process.BusinessActivities)
                .filter(function (activity) {
                    return activity.BusinessActivityId === firstBusinessTask.BusinessActivityId;
                })
                .map(function (activity) {
                    activity.FoundBusinessTasks = [];
                    return activity;
                })
                .value();
                return process;
            })
            .value();
        }

        // All Mode
        else {
            $scope.businessProcesses = _.map(businessProcesses, function (process) {
                process.FoundBusinessActivities = _.map(process.BusinessActivities, function (activity) {
                    activity.FoundBusinessTasks = [];
                    return activity;
                });
                return process;
            });
        }
    }

    $scope.$watch('ctxSearchBusinessTask.businessTasks', function (newValue) { updateBusinessProcesses(); }, true);

    // Go to Business Activity
    $scope.goByBusinessActivity = function (businessActivity) {

        var sameAsEmployeeId;
        if (!_.isUndefined($scope.sameAsEmployee)) {
            sameAsEmployeeId = $scope.sameAsEmployee.EmployeeID;
        }

        businessProcessService.getBusinessTasksByBusinessActivity(businessActivity.BusinessActivityId)
        .then(function (businessTasks) {
            if (businessTasks.length > 0) {
                var firstTask = businessTasks[0];

                $state.go('userAccessRequest.edit.taskcatalog.businessactivity.businesstask', {
                    userAccessRequestId: $scope.userRequest.UserAccessRequestID,
                    businessActivityId: businessActivity.BusinessActivityId,
                    businessTaskId: firstTask.BusinessTaskID,
                    search: $scope.ctxSearchSystem.searchTerm,
                    sameAsEmployeeId: sameAsEmployeeId
                }, { reload: true });
            }
            else {
                $state.go('userAccessRequest.edit.taskcatalog.businessactivity', {
                    userAccessRequestId: $scope.userRequest.UserAccessRequestID,
                    businessActivityId: businessActivity.BusinessActivityId,
                    search: $scope.ctxSearchSystem.searchTerm,
                    sameAsEmployeeId: sameAsEmployeeId
                }, { reload: true });
            }

        });
    }
}]);